import { z } from 'zod';

const ReleaseNoteChangeLog = z.object({
  id: z.string(),
  priority: z.number(),
  text: z.string().nullable(),
  link: z.string().nullable(),
});

const ReleaseNote = z.object({
  id: z.string(),
  system: z.string().nullable(),
  isVisible: z.boolean(),
  version: z.string().nullable(),
  insertDatetime: z.string(),
  changelogData: ReleaseNoteChangeLog.array().nullable(),
});

const ReleaseNotesQuery = ReleaseNote.array();

type ReleaseNotesQuery = z.infer<typeof ReleaseNotesQuery>;
type ReleaseNote = z.infer<typeof ReleaseNote>;

export { ReleaseNotesQuery, ReleaseNote };
